import React from 'react';
import './profile.css';
import { UserInfo } from '../../components/UserInfo/UserInfo';



export function ProfilePage() {
  return <div className="profile-page">
    <UserInfo />
  </div>
} 